export default defineNuxtPlugin(async (nuxtApp) => {
  const [globalPageSettings, dictionary, audiences] = await Promise.all([
    import('./03.globalPageSettings.client.internal'),
    import('./05.dictionary.client.internal'),
    import('./11.audiences.internal')
  ]);

  // init these async plugins in parallel
  await Promise.all([
    globalPageSettings.default(nuxtApp),
    dictionary.default(nuxtApp),
    audiences.default(nuxtApp)
  ]);
});
